import { render, staticRenderFns } from "./VChartComponent.vue?vue&type=template&id=17d34780&scoped=true"
import script from "./VChartComponent.vue?vue&type=script&lang=js"
export * from "./VChartComponent.vue?vue&type=script&lang=js"
import style0 from "./VChartComponent.vue?vue&type=style&index=0&id=17d34780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d34780",
  null
  
)

export default component.exports